import {
  Box,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
} from '@mui/material';
import { useGetTenants } from '@/api/clients/getTenants.ts';

type TenantsFormControlProps = {
  value: string[];
  onChange: (prefixes: string[]) => void;
};

export const TenantsFormControl = ({
  value,
  onChange,
}: TenantsFormControlProps) => {
  const { data: tenants = [], isError } = useGetTenants();

  return (
    <FormControl fullWidth>
      <InputLabel id='tenants-label'>Tenants</InputLabel>
      <Select
        labelId='tenants-label'
        id='select-multiple-tenant-select'
        // multiple
        value={value}
        onChange={(event) => onChange(event.target.value as string[])}
        input={<OutlinedInput id='select-multiple-tenant' label='Chip' />}
        renderValue={(selected) => (
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: 0.5,
            }}
          >
            {selected.map((value) => (
              <Chip
                key={value}
                label={value}
                sx={{
                  height: '23px',
                }}
              />
            ))}
          </Box>
        )}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 48 * 4.5 + 8,
              width: 250,
            },
          },
        }}
      >
        {tenants.map((tenant) => (
          <MenuItem key={tenant.prefix} value={tenant.prefix}>
            {tenant.prefix}
          </MenuItem>
        ))}
      </Select>
      {isError && (
        <Typography color='tomato' fontSize={14}>
          Error while retrieving tenants
        </Typography>
      )}
    </FormControl>
  );
};
